import { useOpenCompanyWindow } from './use-open-company-overview.js';
import { ShortlistButton } from './watchlist-button.js';

// Action row inside a map site popup (Map + Bolt-On panels). Two controls:
//   1. "Company information" — pops up a NEW Company Overview window for that
//      company (independent, pinned — doesn't hijack an already-open Overview).
//   2. "Add to watchlist" — the same multi-watchlist dropdown the Overview
//      header uses (shared ShortlistButton).
export function MapPopupActions({ entityId }: { entityId: string }) {
  const openCompanyWindow = useOpenCompanyWindow();
  return (
    <div className="hc-map-popup-actions">
      <button
        type="button"
        className="hc-map-popup-action"
        onClick={() => openCompanyWindow(entityId)}
      >
        Company information
      </button>
      <ShortlistButton entityId={entityId} />
    </div>
  );
}
